export default [
  {
    name: 'task',
    path: '/task',
    meta: {
      title: '任务面板',
      href: '/task',
      redirect: 'noredirect',
      projectStatus: true,
      isTab: true,
      active: '/main'
    },
    component: () => import( /* webpackChunkName: 'task' */ '@/views/task/taskSuper'),
  },
]
